import React from 'react';
import { registry } from '../../core/Registry.js';
import { BaseWidget } from '../BaseWidget.jsx';

export function StarRatingRender({ node }) {
  const content = node.content || {};
  
  const rating = parseFloat(content.rating) || 4.5;
  const maxStars = parseInt(content.maxStars, 10) || 5;
  const size = content.size || '24px';
  const color = content.color || '#fbbf24'; // amber-400
  const emptyColor = content.emptyColor || 'rgba(255,255,255,0.2)';
  const align = content.align || 'center';

  // Prozentuale Füllung berechnen (z.B. für 4.5 Sterne -> 4 Sterne voll, 1 halb, Rest leer)
  // Das machen wir über ein Clipping-Wrapper Div
  const percentage = Math.min(Math.max((rating / maxStars) * 100, 0), 100);

  const starString = '★'.repeat(maxStars);

  return (
    <div style={{
      display: 'flex',
      justifyContent: align === 'center' ? 'center' : align === 'right' ? 'flex-end' : 'flex-start',
      width: '100%',
      position: 'relative',
      fontSize: size,
      lineHeight: 1,
      letterSpacing: '2px'
    }}>
      {/* Background (Empty) Stars */}
      <div style={{ color: emptyColor, position: 'relative' }}>
        {starString}
        
        {/* Foreground (Filled) Stars Overlay */}
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          color: color,
          width: `${percentage}%`,
          overflow: 'hidden',
          whiteSpace: 'nowrap'
        }}>
          {starString}
        </div>
      </div>
    </div>
  );
}

registry.register('StarRating', {
  label: 'Sterne-Bewertung',
  icon: '⭐', 
  category: 'advanced', // oder basic
  component: StarRatingRender,
  
  defaultProps: {
    content: {
      rating: '4.5',
      maxStars: '5',
      size: '24px',
      color: '#fbbf24',
      emptyColor: 'rgba(255,255,255,0.2)',
      align: 'center'
    },
    style: {
      desktop: {
        marginBottom: '10px'
      }
    }
  },

  inspectorControls: [
    {
      tab: 'content',
      groups: [
        {
          title: 'Wertung',
          fields: [
            { name: 'content.rating', label: 'Bewertung (z.B. 4.5)', type: 'text' },
            { name: 'content.maxStars', label: 'Max. Sterne (z.B. 5)', type: 'select', options: ['5', '10'] }
          ]
        },
        {
          title: 'Design',
          fields: [
            { name: 'content.size', label: 'Sterne-Größe', type: 'text' },
            { name: 'content.color', label: 'Füll-Farbe', type: 'color' },
            { name: 'content.emptyColor', label: 'Leere Farbe', type: 'color' },
            { name: 'content.align', label: 'Ausrichtung', type: 'select', options: ['left', 'center', 'right'] }
          ]
        }
      ]
    }
  ]
});
